import type { SectionConfig } from '../../config';
import { FieldsRenderer } from '../../fields-renderer';
import { SectionShell } from '../section-shell';

export type LeaseInformationSectionProps = {
  config: SectionConfig;
};

export const LeaseInformationSection = ({ config }: LeaseInformationSectionProps) => (
  <SectionShell
    title={config.title}
    subtitle={config.subtitle}
    slots={config.slots}
    spacing={config.spacing}
  >
    <FieldsRenderer fields={config.fields} sectionKey="leaseInformation" />
  </SectionShell>
);
